import React, { useState } from 'react'
import { FolderIcon } from '../../utils/svgs'
import { ResourceFolder } from '../../utils/interfaces';

interface Props {
  folder: ResourceFolder
  selectedId: string
  setSelectedId: React.Dispatch<React.SetStateAction<string>>
  movingFolderId?: string
}

const SelectFolderButton: React.FC<Props> = (props) => {

  const [isOpen, setIsOpen] = useState(false);
  const [folder, setFolder] = useState(props.folder);

  return (
    <>
      <div className={`h-5 rounded flex items-center justify-between`} key={`select-${folder.id}`}>
        {/* name */}
        <div className='flex items-center h-full flex-1 overflow-hidden'>
          <i onClick={() => setIsOpen(!isOpen)} className={`w-4 cursor-pointer ml-0.5 flex items-center justify-center text-xs fa-solid fa-angle-${isOpen ? 'down' : 'right'}`} />
          <div onClick={() => props.setSelectedId(folder.id)} className={`h-full rounded hover:bg-gray-700 flex-1 flex items-center cursor-pointer ${folder.id === props.selectedId ? 'bg-gray-700' : ''}`}>
            <div className={`h-4 p-1`}><FolderIcon /></div>
            <div className={`text-xs flex-1 overflow-hidden text-ellipsis text-nowrap`}>{folder.name}</div>
          </div>
        </div>
      </div>
      {isOpen && <div className='ml-2.5 border-l'>
        {folder.items.filter(item => item.id !== props.movingFolderId).map(item =>
          (item as ResourceFolder).items ?
            <SelectFolderButton
              movingFolderId={props.movingFolderId}
              folder={item as ResourceFolder}
              selectedId={props.selectedId}
              setSelectedId={props.setSelectedId}
            />
            : <></>)}
      </div>}
    </>
  )
}

export default SelectFolderButton